<template>
    <div class="home-page">
        <Header></Header>
        <!-- 面包屑导航 -->
        <div class="breadcrumbs">
          <div class="breadcrumbs-content m_section_inner disflex">
            <div class="bd-ul">
              <ul class="">
                <li class="home"><a href="./">{{$t('home')}}</a></li>
                <li><span>{{$t('Kanji')}}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_title">
          <div class="m_section_inner" style="background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0)), url(../../static/images/Kanji-Title-Pic.jpg) no-repeat 0 0 / cover ">
            <div class="disflex sub-content">
              <div class="disflex topic-header">
                <div class="topic-titles">
                  <div class="jp fw7">かんじ</div>
                  <div class="jp">{{$t('Kanji')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
		<div class="">
      <div class="content crfff por">
        <div class="kanji-content mt30">
          <div class="" :id="'Topic'+(index+1)" v-for="(item,index) in list">
            <div class="step1 disflex">
              <div class="step1-num" style="width: 130px;
height: 130px;
display: flex;
justify-content: center;
align-items: center;
text-align: center;">{{item.title.topic_en}}{{$t('Topic')}}{{index+1}}</div>
              <div class="step1-content">
                <strong>{{item.title.jp_title}}</strong>
                <div><em>{{ item.title.yin_title }}</em>/{{item.title.en_title}}</div>
              </div>
            </div>
            <div class="grammar-detail">
              <div class="kanji-ul">
                <ul>
                  <li v-for="(item1,index1) in item.list"  @click="getToDetail(item1)" class="kanji-li"><img width="90" :src="item1.word_image"/></li>
                </ul>
                <div class="disflex" style="justify-content: right;">
                  <div class="Practice text-shadow mt20" @click="getToAnswer('Topic'+(index+1))">{{$t('Practice')}}<img src="../../static/images/up.png"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
		</div>

      <Dialog ref="levelDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <h2 class="ac mt30 font-family " style="color: #2a2d5a;font-size: 50px"> {{$t('Grammar_tips')}}</h2>
          </div>
          <div class="sure_btn" @click="closeBuyPopup">
            <button class=" btn6 font-family mt20" style="line-height: 103px;color: #fff;font-size: 30px;" >{{$t('OK')}}</button>
          </div>
        </div>
      </Dialog>

	</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        list:[],
        typeList:[],
        type:'',
        info:{}
      }
    },
	created(){
    this.getList();
	},
    mounted() {
      // 在组件挂载后检查URL hash并滚动到对应位置
      this.$nextTick(() => {
        this.scrollToHash();
      });
    },
    watch: {
      // 监听路由变化，当hash变化时滚动到对应位置
      '$route'(to, from) {
        if (to.hash !== from.hash) {
          this.$nextTick(() => {
            this.scrollToHash();
          });
        }
      },
      // 监听list数据加载完成
      'list'() {
        // 数据加载完成后滚动到hash位置
        this.$nextTick(() => {
          this.scrollToHash();
        });
      }
    },
    methods: {
      getToAnswer(type){
        this.$router.push({path:'/KanjiAnswer#'+type,query: {}});
      },
      getToDetail(item){
        this.$router.push({path:'/KanjiDetail',query: {id:item.id}});
      },
      getList(){
        let that = this
        that.$parent.loadModal(true);
        that.$api.post('/api/kanji/list',null,r =>{
          that.$parent.returnCode(r,function(){
            that.list = r.data
            that.$parent.loadModal(false);
          })
        })
      },
      closeBuyPopup(){
        this.$refs.levelDialog.closeMask();
        this.$router.push({path:'/',query: {}});
      },
      statusText(status) {
        switch (status) {
          case 1: return this.$t('no_start')
          case 2: return this.$t('in_process')
          case 3: return this.$t('finished')
          default: return ''
        }
      },
      // 滚动到hash对应的元素
      scrollToHash() {
        if (this.$route.hash) {
          const hash = this.$route.hash.slice(1); // 去掉#号
          const element = document.getElementById(hash);
          if (element) {
            // 计算元素位置并添加140px偏移
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - 150;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });

            // 备用方案：使用scrollIntoView with offset
            // const yOffset = -150;
            // const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            // window.scrollTo({top: y, behavior: 'smooth'});
          }
        }
      }
	}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/Kanji.vue